//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import socialUserAvatarTemplate from '@partials/social-user-avatar.html';
import ava_defaultImage from '@images/ava_default.png';

(function() {
  const socialLinkCtrl = function($scope) {
    const network = $scope.network ? $scope.network.toLowerCase() : '';

    $scope.avaDefaultImage = ava_defaultImage;

    switch (network) {
      case 'instagram':
        $scope.target = '_blank';
        $scope.href = $scope.defaultUrl || `http://instagram.com/${$scope.username}`;
        break;
      case 'facebook':
        $scope.target = '_blank';
        $scope.href = $scope.defaultUrl || `http://instagram.com/${$scope.username}`;
        break;
      default:
        $scope.target = '_blank';
        $scope.href = $scope.defaultUrl;
    }
  };

   /**
    * A link that goes either internally to Explore or externally to the relevant social network.
    *
    * @param network {string}      The network for the link. Currently supports Instagram.
    * @param username {string}     A network username.
    * @param userId {string}       [optional] A network user id.
    * @param defaultUrl {string}   [optional] A default url to use if 1) explore is not enabled or 2) the social network is not supported.
    *
    */
  angular.module('curalate').directive('socialUserLink', () => ({
    restrict: 'E',
    scope: {
      network: '@',
      username: '@',
      userId: '@?',
      defaultUrl: '@?',
    },
    replace: true,
    transclude: {
      'content': '?content',
    },
    template: '<a class="social-user-link" ng-class="::{\'invalid\': !href}" ng-href="{{::href}}" target="{{::target}}">' +
                          '<span ng-transclude="content">{{::username}}</span>' +
                      '</a>',
    controller: ['$scope', socialLinkCtrl],
  }));

    /**
    * A user avatar that links either internally to Explore or externally to the relevant social network.
    *
    * @param network                    The network for the link. Currently supports Instagram.
    * @param profilePhotoUrl {string}   The url to use for the avatar.
    * @param username {string}          [optional] A network username.
    * @param userId {string}            [optional] A network user id.
    * @param defaultUrl {string}        [optional] A default url to use if 1) explore is not enabled or 2) the social network is not supported.
    *
    */
  angular.module('curalate').directive('socialUserAvatar', () => ({
    restrict: 'E',
    scope: {
      network: '@',
      profilePhotoUrl: '@',
      username: '@?',
      userId: '@?',
      defaultUrl: '@?',
    },
    replace: true,
    template: socialUserAvatarTemplate,
    controller: ['$scope', 'SessionVarsService', socialLinkCtrl],
  }));
})();
